import { CartScopeEq } from '@/models/cart/group/scope'
import { ApiClient } from '@/services/api/client'
import { Either, left, right } from 'fp-ts/lib/Either'

export interface CartScopeStateService {
  status(scope: CartScopeEq): Promise<Either<Error, CartScopeStatus>>
}

export interface CartScopeStatus {
  available: boolean
}
export class CartScopeService implements CartScopeStateService {
  static create(): CartScopeService {
    return new CartScopeService(ApiClient)
  }

  private constructor(private readonly apiClient: typeof ApiClient) {}

  async status(scope: CartScopeEq): Promise<Either<Error, CartScopeStatus>> {
    try {
      const res = await this.apiClient.get(
        `/api/common/cart/scope/${scope.kind.toString()}/${scope.value.toString()}/state`
      )

      return right(res.body.data)
    } catch (e) {
      return left(e)
    }
  }
}
